module.exports = __webpack_public_path__ + "static/clients-2ddc901fe55878af0f1ca1b487e619d7.gif";